import { Chip } from '@w7/ui'

/** Flags that drive PL Statement Event chips (Invalid Bet vs Invalidate P&L). */
export type PlStatementStatusFlags = {
  isInvalid?: boolean
  isRollback?: boolean
  isPNLInvalid?: boolean
  isPNLRollBack?: boolean
}

/** Lab-style status chips under the Event cell — distinct Invalid Bet vs P&L. */
export function PlStatementStatusChips({ row }: { row: PlStatementStatusFlags }) {
  const chips: Array<{ key: string; label: string; tone: 'warn' | 'muted' }> = []
  if (row.isRollback) chips.push({ key: 'ib-rb', label: 'Rollback Bet', tone: 'muted' })
  if (row.isInvalid) chips.push({ key: 'ib', label: 'Invalid Bet', tone: 'warn' })
  if (row.isPNLRollBack) chips.push({ key: 'pnl-rb', label: 'P&L Rollback', tone: 'muted' })
  if (row.isPNLInvalid) chips.push({ key: 'pnl', label: 'Invalidate P&L', tone: 'warn' })
  if (!chips.length) return null
  return (
    <span style={{ display: 'inline-flex', gap: 4, flexWrap: 'wrap' }}>
      {chips.map((c) => (
        <Chip key={c.key} size="sm" tone={c.tone}>
          {c.label}
        </Chip>
      ))}
    </span>
  )
}
